import { apiFetch } from './client';

// Base products APIs
export async function fetchProducts() {
    const res = await apiFetch('/api/products');
    if (!res.ok) throw new Error('Errore caricamento prodotti');
    return res.json();
}

export async function createProduct(data: any) {
    const res = await apiFetch('/api/products', { method: 'POST', body: JSON.stringify(data) });
    if (!res.ok) throw new Error('Errore creazione prodotto');
    return res.json();
}

export async function updateProduct(id: number, data: any) {
    const res = await apiFetch(`/api/products/${id}`, { method: 'PUT', body: JSON.stringify(data) });
    if (!res.ok) throw new Error('Errore aggiornamento prodotto');
    return res.json();
}

export async function deleteProduct(id: number) {
    const res = await apiFetch(`/api/products/${id}`, { method: 'DELETE' });
    if (!res.ok) throw new Error('Errore eliminazione prodotto');
}

// Variants
export async function fetchVariants(productId: number) {
    const res = await apiFetch(`/api/products/${productId}/variants`);
    if (!res.ok) throw new Error('Errore caricamento varianti');
    return res.json();
}

export async function createVariant(productId: number, data: any) {
    const res = await apiFetch(`/api/products/${productId}/variants`, { method: 'POST', body: JSON.stringify(data) });
    if (!res.ok) throw new Error('Errore creazione variante');
    return res.json();
}

export async function updateVariant(variantId: number, data: any) {
    const res = await apiFetch(`/api/products/variants/${variantId}`, { method: 'PUT', body: JSON.stringify(data) });
    if (!res.ok) throw new Error('Errore aggiornamento variante');
    return res.json();
}

export async function deleteVariant(variantId: number) {
    const res = await apiFetch(`/api/products/variants/${variantId}`, { method: 'DELETE' });
    if (!res.ok) throw new Error('Errore eliminazione variante');
}

// Menu tree ricostruito dal nuovo snapshot unificato (categories, subcategories, products)
export async function fetchMenuTree() {
    const res = await apiFetch('/api/menu/snapshot');
    if (!res.ok) throw new Error('Errore caricamento snapshot');
    const text = await res.text();
    let snap: any;
    try { snap = JSON.parse(text); } catch (e) { throw new Error('Snapshot non parseable: ' + text.slice(0, 80)); }
    const cats = Array.isArray(snap.categories) ? snap.categories : [];
    const subs = Array.isArray(snap.subcategories) ? snap.subcategories : [];
    const prods = Array.isArray(snap.products) ? snap.products : [];
    // Costruiamo struttura compatibile con quella precedente usata dal gestionale
    const subsByCat = new Map<number, any[]>();
    subs.forEach((s: any) => {
        const cid = s.categoryId || (s.category && s.category.id);
        if (!cid) return;
        if (!subsByCat.has(cid)) subsByCat.set(cid, []);
        subsByCat.get(cid)!.push(s);
    });
    const itemsByCat = new Map<number, any[]>();
    const itemsBySub = new Map<number, any[]>();
    prods.forEach((p: any) => {
        if (p.subcategoryId) {
            if (!itemsBySub.has(p.subcategoryId)) itemsBySub.set(p.subcategoryId, []);
            itemsBySub.get(p.subcategoryId)!.push(p);
        } else if (p.categoryId) {
            if (!itemsByCat.has(p.categoryId)) itemsByCat.set(p.categoryId, []);
            itemsByCat.get(p.categoryId)!.push(p);
        }
    });
    const tree = cats.map((c: any) => {
        const cid = c.id;
        const catSubs = subsByCat.get(cid) || [];
        return {
            category: c,
            items: itemsByCat.get(cid) || [],
            subcategories: catSubs.map(sc => ({
                subcategory: sc,
                items: itemsBySub.get(sc.id) || []
            }))
        };
    });
    return tree;
}
